import { render, staticRenderFns } from "./textInputItem.vue?vue&type=template&id=6c4cb888"
import script from "./textInputItem.vue?vue&type=script&lang=js"
export * from "./textInputItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports